import React from 'react';
import { connect } from 'react-redux';

import gameKit from '../../../../GameKit';

import settings from '../../../../settings';

// GameGuide imports
import GuideStepContainer from '../layout';
import { nextStep, prevStep } from '../../../actions/gameGuideActions';
import CheckBox from '../../Default/CheckBox';
import RadioButton from '../../Default/RadioButton';

import { GameGoalFlag, GameScoreEnum } from '../../../../Game/Enums';

class GuideStepGoal extends React.Component {
    onNext = () => {
        const { dispatch } = this.props;
        dispatch(nextStep());
    };

    onPrev = () => {
        const { dispatch } = this.props;
        dispatch(prevStep());
    };

    onSelectGoal = e => {
        const optionGoal = parseInt(e.target.value, 10);
        const {
            game: { goal }
        } = this.props;

        const newGoal = goal ^ optionGoal;

        gameKit.updateGameSettings({
            goal: newGoal
        });
    };

    onSelectScore = e => {
        const newScore = parseInt(e.target.value, 10);
        gameKit.updateGameSettings({
            score: newScore
        });
    };

    render() {
        const { id, game } = this.props;

        return (
            <GuideStepContainer
                title={
                    <div className="step-goal-row">
                        <div className="step-goal-column">Speldoel</div>
                        <div className="step-goal-column">Score</div>
                    </div>
                }
                id={id}
                hasSaveButton
            >
                <div className="step-goal-row">
                    <div className="step-goal-column">
                        <GameGoals goal={game.goal} onChange={this.onSelectGoal} />
                    </div>
                    <div className="step-goal-column step-goal-score">
                        <div className="gamegoal">
                            <div className="gamegoal-icon">
                                <img src={`${settings.assetsPath}img/icons/muntje.png`} alt="Punten tellen altijd mee" />
                            </div>
                            <div className="gamegoal-label always-score">Punten tellen altijd mee</div>
                        </div>
                        <hr />
                        <div className="gamegoal">
                            <div className="gamegoal-icon">
                                <img src={`${settings.assetsPath}img/icons/clock.png`} alt="Telt tijd mee" />
                            </div>
                            <div className="gamegoal-label">Telt tijd mee</div>
                        </div>
                        <ScoreOptions score={game.score} onChange={this.onSelectScore} />
                    </div>
                </div>
                <div className="buttons-container">
                    <button type="button" onClick={this.onPrev} className="gamegoal-button gamegoal-prev-button">
                        terug
                    </button>
                    <button type="button" onClick={this.onNext} className="gamegoal-button gamegoal-next-button">
                        verder
                    </button>
                </div>
            </GuideStepContainer>
        );
    }
}

function GameGoal({goal, curGoals, onChange}) {
    const name = GameGoalFlag.getString(goal);
    return (
        <div key={1 << goal} className="gamegoal-container">
            <CheckBox name={name} value={goal} checked={curGoals & goal} onChange={onChange}>
                <div className="gamegoal">
                    <div className="gamegoal-icon">
                        <img src={`${settings.assetsPath}img/icons/${GameGoalFlag.getIcon(goal)}`} alt={name} />
                    </div>
                    <div className="gamegoal-label">{name}</div>
                </div>
            </CheckBox>
        </div>
    );
}

function GameGoals({ goal, onChange }) {
    return (
        <>
            <GameGoal goal={GameGoalFlag.FINISH} curGoals={goal} onChange={onChange} />
            <GameGoal goal={GameGoalFlag.POINT_LIMIT} curGoals={goal} onChange={onChange} />
            <div className="gamegoal-container gamegoal gamegoal-dead">
                <div className="gamegoal-icon">
                    <img src={`${settings.assetsPath}img/icons/dead.png`} alt="Spelen tot je dood gaat!" />
                </div>
                <div className="gamegoal-label">
                    <div className="gamegoal-toplabel">Kies je niets? Dan wordt het:</div>
                    <div className="gamegoal-bottomlabel">Spelen tot je dood gaat!</div>
                </div>
            </div>
            <hr />
            <GameGoal goal={GameGoalFlag.TIME_LIMIT} curGoals={goal} onChange={onChange} />
        </>
    );
}

function ScoreOptions({ score, onChange }) {
    const options = [];
    for (let i = 0; i < GameScoreEnum.OUT_OF_BOUNDS; ++i) {
        options.push(i);
    }

    return Object.keys(options).map(option => {
        const intOption = parseInt(option, 10);
        return (
            <div className="gamegoal-radio" key={intOption}>
                <RadioButton key={option} name="score-option" value={intOption} activeValue={score} onChange={onChange}>
                    {GameScoreEnum.getString(intOption)}
                </RadioButton>
            </div>
        );
    });
}

GuideStepGoal.defaultProps = {};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game,
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GuideStepGoal);
